import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

const LinkButton: React.FC<LinkButtonProps> = ({
    color = 'blue',
    href = '',
    icon,
    iconSide = 'left',
    children,
    extraClasses = '',
    target = '',
}) => (
    <Link to={href} className={`button ${color} ${extraClasses}`} target={target}>
        {icon && <i className={`icon far fa-fw fa-${icon} ${iconSide}`}></i>}
        <span className="text">{children}</span>
    </Link>
);

interface LinkButtonProps {
    children: ReactNode;
    color?: string;
    extraClasses?: string;
    href?: string;
    icon?: string;
    iconSide?: 'left' | 'right';
    target?: '' | '_blank';
}

export default LinkButton;
